import { Button, ButtonGroup, Paper } from "@mui/material";
import { useState } from "react";
import { FaArrowCircleRight, FaGoodreadsG, FaLinkedin, FaGithub } from "react-icons/fa";
import { GrMail } from "react-icons/gr";
import moment from "moment";

export const AboutMeCard = ({hideBackCard = false}) => {
    const [flip, setFlip] = useState(false);
    const months = moment().diff('2021-07-05', 'months');
    const [educationClicked, setEducationClicked] = useState(false);
    const [workClicked, setWorkClicked] = useState(false);
    return (
        <div className={`bg-gradient-to-b from-purple-400  to-purple-600 w-10/12 lg:w-10/12 mt-10 lg:ml-10 lg:mr-10  rounded-lg lg:mt-10 lg:pb-5 card ${flip ? 'flip' : ''}`}>
            <div className="front lg:absolute">
                <div className="text-center pt-4 pl-5 font-bold">
                    About Me 
                    <a href="https://www.linkedin.com/in/shreyas-thirumalai-bb142315a/" title="Linkedin Profile">
                        <FaLinkedin className="inline-block ml-2" /> 
                    </a>
                    <a href="https://github.com/shreyas1599" title="Github Profile">
                        <FaGithub className="inline-block ml-2" /> 
                    </a>
                    <a href="mailto:shreyasthirumalai@gmail.com" title="Email Me!">
                        <GrMail className="inline-block ml-2" />
                    </a>
                    <a href="https://www.goodreads.com/user/show/39148020-shreyas" title="Goodreads Profile">
                        <FaGoodreadsG className="inline-block ml-2"  />
                    </a>
                </div>
                <div className="p-6 drop-shadow-xl">
                    Hi! 👋 I'm <b>Shreyas.</b> I've been working for <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-pink-800 font-bold">{months} months </span>
                    as a Software Engineer at 👨‍💻 <b><span className={`text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800 ${!workClicked ? 'animate-pulse' : ''} `}><a href="#work" onClick={() => setWorkClicked(true)}>Goldman Sachs</a></span></b>. My work there involves working on a large scale trading platform
                    that is used to manage the company's financial inventory. I've industry experience in both backend and frontend development. 
                    On the frontend side, I've worked with React, grid and charting frameworks like Ag-grid and Highcharts. On the backend side, I've mainly worked on ETL pipelines built on Kafka. 
                    I've also dabbled in open source by contributing a decent amount to a <span className="hover:border-b-4 border-red-600 text-transparent bg-clip-text bg-gradient-to-r from-pink-700 to-pink-800 font-bold"><a href="https://github.com/git-touch/git-touch">Flutter repo</a></span>.
                    My educational qualifications
                    include a Bachelors in Computer Science and Engineering degree from 📜 <span className={`text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800 ${!educationClicked ? 'animate-pulse' : '' }`}><a href="#education" onClick={() => setEducationClicked(true)}><b>NIT Trichy</b></a></span>.
                    <br /> <br />
                    In my free time, I like reading novels, especially crime fiction. I also practice Spanish fairly regularly on Duolingo. A life goal of mine is to visit 
                    Spain and most of South America and travel around without speaking a lick of English.
                    🚴‍♂️ Cycling and 🚶‍♂️ walking are other interests of mine.
                    {/* <div className="lg:grid place-items-end mb-3 invisible lg:visible"><FaArrowCircleRight size={'1.4rem'} onClick={() => setFlip(!flip)}/></div> */}
                </div>
            </div>
            {!hideBackCard && 
                <div className="w-full back lg:absolute invisible lg:visible">
                    <div className="text-center pt-4 font-bold">2023 Goals!</div>
                    <div className="p-6 drop-shadow-xl">
                        🚀 <b>Travel 2</b> New Countries (<b>Thailand</b> 🇹🇭 and <b>Cambodia</b> 🇰🇭 are on the list for this year)! <br />
                        🗣️ Hold a conversation in <b>Spanish</b><br />
                        📚 Read <b>50</b> Books. <br />
                        🏃‍♂️ Be able to run <b>~10km</b> without effort <br />
                        🤖 To be filled soon ...
                    </div>
                    <div className="lg:grid place-items-end mb-0 lg:mr-6"><FaArrowCircleRight size={'1.4rem'}  onClick={() => setFlip(!flip)}/></div>
                </div>
            }
            {/* </div> */}
        </div>
    );
};